// removed by extract-text-webpack-plugin
module.exports = {"dialog":"helpContainer-module-dialog-ef7ee72ee2a9174afa2852ccee3858d8--","overlay-container":"helpContainer-module-overlay-container-de85b6e5f27403854b0bce14e8c4637c--"};


//////////////////
// WEBPACK FOOTER
// /src/components/header/helpContainer/helpContainer.module.scss
// module id = 1719
// module chunks = 0